export function getCurrencySymbolByZoneId(zoneId: string): string {
  const currencyMap: Record<string, string> = {
    // Londres (Reino Unido) → Libra esterlina
    '79dff00a-b262-46c8-8d54-0aa6d4325d87': '£',
    // Chile → Peso chileno
    'f8ec5b35-070e-4701-8b5e-786958c6d272': 'CLP',
    // París y resto de zonas en España y Francia quedan por defecto en Euro
  };

  // Si no está en el mapa, devolvemos el Euro
  return currencyMap[zoneId] || '€';
}
